const al = {
  unlimited_offer_step: 'Oferta',
  unlimited_id_step: 'Verifikimi',
  unlimited_group_step: 'Grupi',
  unlimited_installation_step: 'Instalimi',
  unlimited_summary_step: 'Përfundimi',
  unlimited_offer_description:
    'E re!. Të gjithë anëtarët e familjes së bashku përfitojnë më shumë. Ju jeni në më të mirën tuaj kur jeni në grup. Tani të gjitha shërbimet fikse dhe celulare me një ofertë të vetme.',
  unlimited_my_offer: 'Shtëpia Jonë',
  unlimited_family_offer: 'Oferta për familjen',
  unlimited_end_of_offer: 'nga përfundimi i ofertës',
  unlimited_offer_title: 'Oferta për grupin',
  unlimited_offer_subtitle:
    'Zgjidh rekomandimin ose krijo vetë ofertën që të përshtatet',
  unlimited_offer_pay_period: '%1$s %1$s / muaj',
  unlimited_cart_details_none_selected:
    'Duhet të zgjedhësh planin tënd tarifor, shpejtësinë e Vodafone Giga Fibra dhe anëtarët.',
  unlimited_offer_select_button: 'Vazhdo me këtë paketë',
  unlimited_coverage_title: 'Verifiko mbulimin',
  unlimited_coverage_subtitle:
    'Kërko me adresën tënde dhe verifiko mbulimin për instalimin e shërbimit internet fiks',
  unlimited_processing: 'Duke procesuar të dhënat',
  unlimited_exceeded_slots: '* Ke kaluar limitin e numrit të anëtarëve',
  unlimited_leave_title: 'Largohu nga grupi',
  unlimited_leave_heading:
    'Je i sigurt që do të largohesh nga grupi? Kujdes nëse konfirmon ti do të paguash vetë faturën e numrit',
  unlimited_my_members: 'Grupi im',
  unlimited_my_members_short: 'Anëtarët e grupit',
  unlimited_add_member_number_input: 'Numri i anëtarit',
  unlimited_member_description: 'Menaxho me lehtësi anëtarët e grupit tënd',
  unlimited_group_plan: 'Plani i grupit',
  unlimited_pending_status: 'Në pritje',
  unlimited_add_member_input: 'Shto anëtar',
  unlimited_add_member_info:
    'Mund shtosh deri në %1$s numra Vodafone si anëtarë në grupin tënd.',
  unlimited_leave_group_button: 'Lë grupin',
  unlimited_leave_group_explain: 'Mund të largohesh nga grupi pas datës %1$s',
  unlimited_continue: 'Vazhdo',
  unlimited_back: 'Kthehu',
  unlimited_notify_when_leave:
    'Administratori i grupit do të njoftohet për kërkesën e largimit ...',
  unlimited_leave_group_title:
    'Je i sigurt që do të largohesh nga grupi? Kujdes nëse konfirmon ti do të paguash vetë faturën e numrit',
  unlimited_included_in_offer: 'Të përfshira në planin tënd',
  unlimited_kick_member_title: 'Fshi anëtar',
  unlimited_kick_member_heading:
    'A je i sigurtë që do të largosh nga grupi anëtarin %1$s ?',
  unlimited_kick_member_sub_heading:
    '%1$s do të njoftohet me SMS për ftesën e grupit dhe duhet ta konfirmoj atë brenda 48 orëve.',
  unlimited_add_member_title: 'Shto anëtar të ri',
  unlimited_add_member_heading:
    'A je i sigurt që dëshiron të shtosh numrin %1$s në grupin tënd?',
  unlimited_view_details: 'Shiko detajet',
  unlimited_no_slots_selected:
    'Nuk ke zgjedhur opsionin e anëtarëve, por mund të vazhdosh me ofertën dhe ti shtosh më pas tek menaxhimi i grupit.',
  unlimited_id_title: 'Vendos ID tënde',
  unlimited_id_description:
    'Vendos numrin personal 10 shifror të kartës së identitetit',
  unlimited_next_step_button: 'Vazhdo',
  unlimited_id_form_title: 'Foto ID',
  unlimited_id_form_subtitle: 'Verifiko Identitetin',
  unlimited_id_upload_description:
    'Vendos numrin 10 shifror të kartës së identitetit dhe fotografojeni atë për të verfikuar të dhënat e regjistrimit në Vodafone.',
  unlimited_id_upload_button: 'Fotografo ID',
  unlimited_id_uploaded_button: 'Fotografitë e ID u ngarkuan',
  unlimited_id_personal_number_label: 'Numri personal',
  unlimited_id_name_label: 'Emri',
  unlimited_id_email_label: 'Email',
  unlimited_id_surname_label: 'Mbiemri',
  unlimited_id_country_label: 'Vendi lëshues',
  unlimited_id_month_label: 'Muaji',
  unlimited_expiration_month_label: 'Muaji i skadimit',
  unlimited_id_year_label: 'Viti',
  unlimited_expiration_year_label: 'Viti i skadimit',
  unlimited_group_creation_title: 'Emërto grupin',
  unlimited_create_group_description:
    'Shto anëtarë që gjithsecili të marrë maksimumin e përfitimeve të planit NEXT+ / Unlimited',
  unlimited_creation_sms_confirmation:
    'Secili nga anëtarët që ka dhënë pëlqimin, do të kalojë automatikisht në planin tarifor NEXT+ / Unlimited dhe duhet të qëndroj minimalisht 3 muaj në grup.',
  unlimited_group_name_description:
    'Emërto grupin dhe shto deri në %1$s anëtarë',
  unlimited_group_name_label: 'Emri i grupit',
  unlimited_installation_title: 'Instalimi',
  unlimited_installation_description:
    'Përcakto datën e preferuar për vizitën e instalimit',
  unlimited_installation_fee_title: 'Tarifa e Instalimit',
  unlimited_installation_fee_subtitle:
    'Kjo tarifë do të paguhet në faturën e parë',
  unlimited_installation_fee_label: 'Tarifa e instalimit',
  unlimited_summary_selection_title: 'Shtëpia Jonë',
  unlimited_summary_members_description: 'Shiko anëtarët e grupit tënd.',
  unlimited_summary_cost_total: 'Kosto totale',
  unlimited_summary_cost_subtitle: 'Çmimi dhe vlefshmëria',
  unlimited_summary_amount: '%1$s Lekë ',
  unlimited_summary_monthly: 'Tarifa mujore',
  unlimited_summary_cost_start: 'Data e fillimit',
  unlimited_summary_cost_duration: 'Kohëzgjatja',
  unlimited_summary_cost_cancel_period: 'Afati për ndryshimin e anëtarëve',
  unlimited_summary_plan_monthly: 'Tarifa mujore',
  unlimited_summary_plan_firstBill: 'Fatura e parë',
  unlimited_summary_duration: '%1$s muaj',
  unlimited_cancel_duration: '6 muaj',
  unlimited_per_month: '%1$s Lekë në muaj',
  unlimited_summary_why: 'Pse?',
  unlimited_summary_breakdown: 'Detaje',
  unlimited_summary_discount: 'Zbritje',
  unlimited_summary_modem_deposit: 'Tarifa e paisjes',
  unlimited_summary_installation_fee: 'Tarifa e instalimit',
  unlimited_summary_total_to_pay: "Totali për t'u paguar",
  unlimited_summary_first_bill: 'Fatura e parë',
  unlimited_summary_recurring: 'Totali mujor (për %1$s muaj)',
  unlimited_summary_confirm_button: 'Konfirmo',
  unlimited_summary_tos_p1: "Duke shtypur 'Konfirmo', ti pranon ",
  unlimited_summary_tos_p2: 'termat dhe kushtet. ',
  unlimited_close: 'Mbyll',
  unlimited_explain_dialog_title: 'Përse fatura ime është %1$s Lekë?',
  unlimited_marked_for_leave: 'Në pritje të largimit',
  unlimited_explain_dialog_explanation:
    'Fatura e parë do të përfshij tarifën e instalimit, tarifën e paisjes si dhe tarifën mujore nga data e marrjes së shërbimit',
  unlimited_total: 'Totali',
  unlimited_home_recommended: 'Rekomandim për ty',
  unlimited_camera_continue: 'Vazhdo',
  unlimited_camera_retake_photo: 'Ribëj foton',
  unlimited_camera_selfie: 'Fotografo portretin tënd',
  unlimited_camera_back_id: 'Fotografo ID tënde nga mbrapa',
  unlimited_camera_front_id: 'Fotografo ID tënde nga përpara',
  unlimited_members_count: '%1$s/%1$s',
  unlimited_no_members_placeholder: 'Grupi do të krijohet pa anëtarë',
  unlimited_members_placeholder:
    "Secili nga anëtarët do të njoftohet me SMS dhe duhet të jap pëlqimin e tij brenda 48 orëve për t'ju bashkuar grupit",
  unlimited_number_already_added:
    'Ky numër është tashmë pjesë e grupit Shtëpia Jonë',
  unlimited_invalid_group_name: 'Vendos një emër për grupin sipas dëshirës',
  unlimited_group_name_length_min:
    'Emri i grupit duhet të ketë të paktën 2 karaktere',
  unlimited_group_name_length_max:
    'Emri i grupit duhet të jetë më pak se 10 karaktere',
  unlimited_member_success_added: '* Shtuar me sukses',
  unlimited_admin_member: 'Administrator',
  unlimited_grace_period_status: 'Mund të modifikohet pas datës %1$s',
  unlimited_filled_slots:
    '* Ke plotësuar të gjitha vëndet për anëtarët e grupit',
  unlimited_error: 'Ndodhi një gabim',
  unlimited_error_adding_title: 'Gabim gjatë shtimit të anëtarit',
  unlimited_try_again: 'Provo përsëri',
  unlimited_continue_without_member: 'Vazhdo pa këtë numër',
  unlimited_rename_group_title: 'Modifiko grupin',
  unlimited_rename_group_header: 'Ndrysho emrin e grupit tënd',
  unlimited_rename_group_desc: 'Ndrysho emrin e grupit sipas dëshirës',
  unlimited_invalid_id: 'Numri personal është i detyrueshëm',
  unlimited_invalid_name: 'Emri është i detyrueshëm',
  unlimited_invalid_email: 'Emaili është i pavlefshëm',
  unlimited_invalid_number: 'Format jo i saktë i numrit të telefonit',
  unlimited_invalid_surname: 'Mbiemri është i detyrueshëm',
  unlimited_admin_number:
    'Administratori nuk mund të shtohet si anëtar i grupit',
  unlimited_already_added: 'Anëtari me këtë numër është i shtuar në grup',
  unlimited_create_plan: 'Krijo ofertën',
  unlimited_create_description:
    'Zgjidh planin tarifor, shpejtësinë dhe anëtarët',
  unlimited_first_benefit: 'Krijo produktin për të gjithë shtëpinë',
  unlimited_second_benefit: 'Fleksibilitet çmimi dhe përdorimi',
  unlimited_third_benefit: 'Merr dhe paguaj të gjitha shërbimet në 1 faturë',
  unlimited_choose_plan_title: 'Zgjidh planin tarifor',
  unlimited_choose_speed_title: 'Zgjidh Vodafone Giga Fibra',
  unlimited_choose_speed_sub: 'Përjeto shpejtësinë e Rrjetit Nr. 1 në Shqipëri',
  unlimited_choose_tv_title: 'Zgjidh Vodafone Giga TV',
  unlimited_choose_tv_sub: 'Argëtim si asnjëherë më parë',
  unlimited_choose_slots_title: 'Zgjidh numrin e anëtarëve',
  unlimited_slots_count: '%1$s anëtar',
  unlimited_valid_until: 'Oferta e vlefshme deri më %1$s',
  unlimited_save: 'Kurse %1$s Lek',
  unlimited_go_back_to_offers: 'Kthehu tek ofertat e rekomanduara',
  unlimited_view_cart_title:
    'Eksploro zgjidhje dhe mundësi pa fund për familjen',
  unlimited_view_cart_cta: 'Shiko produktet',
  unlimited_cart_details_title: 'Ofertë e personalizuar',
  unlimited_cart_details_subtitle: 'Produktet e mia',
  unlimited_mobile_plan: 'Plani i telefonit',
  unlimited_national_calls: 'Telefonata kombëtare',
  unlimited_national_sms: 'SMS kombëtare',
  unlimited_internet: 'Internet',
  unlimited_minutes: '%1$s MIN',
  unlimited_sms_count: '%1$s SMS',
  unlimited_gb: '%1$s GB',
  unlimited_mbps: '%1$s Mbps',
  unlimited_prefer_time: 'Përzgjidh orarin:',
  unlimited_morning_time: 'Paradite',
  unlimited_noon_time: 'Mesdite',
  unlimited_afternoon_time: 'Pasdite',
  unlimited_unable_to_add: 'Anëtari %1$s nuk u shtua.',
  unlimited_one_admin: '\u2022    1 administrator',
  unlimited_slots_count_list: '\u2022    %1$s anëtarë',
  unlimited_tv_name: 'TV %1$s',
  unlimited_channel_count: 'Argëtim si asnjëherë më parë',
  unlimited_channel_count_list: '\u2022    Argëtim si asnjëherë më parë',
  unlimited_more_benefits: 'Përfitime',
  unlimited_standard_offers: 'Ofertat standarte',
  unlimited_speed: 'Shpejtësia',
  unlimited_your_group: 'Grupi yt',
  unlimited_added_members: '%1$s anëtarë të shtuar',
  unlimited_details: 'Detajet e Unlimited Home',
  unlimited_vf_internet: 'Vodafone Giga Fibra',
  unlimited_plan_period: 'Kontratë %1$s mujore',
  unlimited_plan_roaming: 'RED roaming',
  unlimited_plan_vcoins: 'Dyfish Vcoins',
  unlimited_offer_deselect_button: 'Hiq këtë opsion',
  unlimited_order_success_modal: 'New broadband line',
  unlimited_order_success_title: 'Kërkesa u plotësua',
  unlimited_order_success_desc:
    'Instalatorët do të vizitojnë në adresë brenda 48 orëve. Do të njoftojmë me SMS kur të përfundojë instalimi dhe oferta e grupit të jetë aktive.',
  unlimited_order_error_modal: 'Ndodhi një gabim',
  unlimited_unselect_internet: 'Vazhdo pa internet',
  unlimited_unselect_members: 'Vazhdo pa anëtarë',
  unlimited_usage_terms: 'Detajet e përdorimit',
  unlimited_coverage_error: 'Ndodhi një gabim gjatë verifikimit të mbulimit.',
  unlimited_customer_check_error:
    'Ndodhi një gabim gjatë verifikimit të klientit',
  unlimited_plan_select_button: 'Zgjidh këtë plan',
  unlimited_plan_selected_button: 'Plani i zgjedhur',
  unlimited_id_helper_text:
    'Vendos numrin personal 10 shifror të kartës së identitetit',
  unlimited_validating: 'Duke verifikuar të dhënat',
  unlimited_member_pay_explain:
    'Anëtarët do të paguajnë vetë shpenzimet shtesë si psh: paketa shtesë, roaming, parking etj',
  unlimited_terms_and_conditions: 'Termat dhe kushtet',
  unlimited_city: 'Vendlindja',
  unlimited_male: 'Mashkull',
  unlimited_female: 'Femër',
  unlimited_else: 'Tjetër',
  unlimited_gender: 'Gjinia',
  unlimited_birthday_day: 'Data',
  unlimited_birthday_year: 'Viti',
  unlimited_birthday_month: 'Muaji',
  unlimited_home_birthday: 'Datëlindja',
  unlimited_birthday_year_error: 'Viti i lindjes nuk është i saktë',
  unlimited_birthday_month_error: 'Muaji nuk është i saktë',
  unlimited_birthday_day_error: 'Data nuk është e saktë'
}

export default al
